import React, { FC } from 'react';
import useEEActive from '../../../../hooks/useEEActive';
import useGetBuildAndPriceLink, { TProductPageType } from '../../../../hooks/useGetBuildAndPriceLink';
import { appendRootToInternalLink } from '../../../../utils/appendRootToInternalLink.utils';
import { TProductFloatingMenuBuildAndPriceItem } from '../../types/productFloatingMenu.types';
import FloatingMenuLink from '../floatingMenuLink';
import useSitecoreContext from '../../../../hooks/useSitecoreContext';
import templateIds from '../../../../constants/templates.constants';

const BuildAndPriceLink: FC<{ buildAndPriceItem: Partial<TProductFloatingMenuBuildAndPriceItem> }> = (props) => {
  const { id, fields } = props.buildAndPriceItem || {};
  const isEEactive = useEEActive();
  const { sitecoreContext } = useSitecoreContext();

  const productPageTemplateTypeMap: { [key: string]: TProductPageType | undefined } = {
    [templateIds.lineDetailPageTemplateId]: 'line',
    [templateIds.seriesDetailPageTemplateId]: 'series',
    [templateIds.modelDetailPageTemplateId]: 'model',
  };
  const currentPageTemplateId = sitecoreContext?.route?.templateId || '';
  const currentPageType = productPageTemplateTypeMap[currentPageTemplateId];

  // Build and Price Url Line detail and Series detail page
  const productBuildAndPriceUrl = appendRootToInternalLink(useGetBuildAndPriceLink(currentPageType));

  let buildAndPriceUrl: string | undefined;
  if (currentPageType) {
    buildAndPriceUrl = productBuildAndPriceUrl;
  } else if (currentPageTemplateId === templateIds.lineListingPageTemplateId) {
    buildAndPriceUrl = fields?.buildAndPriceLink?.value?.href;
  }

  if (!isEEactive && !buildAndPriceUrl) return null;

  return (
    <FloatingMenuLink
      key={id}
      itemId={id}
      title={fields?.title}
      icon={fields?.icon}
      link={{
        value: {
          href: buildAndPriceUrl,
        },
      }}
    />
  );
};

export default BuildAndPriceLink;
